<div class="story">
  <button class="story__close" (click)="close()" aria-label="Close">
    <i class="fa-solid fa-times"></i>
  </button>

  <!-- Content Container with Animation -->
  <div class="story__content-container pb-3" [@pageTransition]="animationDirection">
    <div class="story__content-wrapper" [@fadeInOut]="currentPageIndex">
      <!-- Tags Section -->
      @if(currentPageShowTags){
      <div class="modern-tags-section-2">
        <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
        <div class="story__title">{{ displayTitle }}</div>
        <div class="tags-counter" *ngIf="selectedTags?.size > 0">{{ selectedTags.size }} selected</div>
        <!-- Biz Tags Section -->
        <div class="tag-category-section" *ngIf="bizTags?.length">
          <div class="tags-container">
            <div class="tag-item" *ngFor="let tag of bizTags; trackBy: trackByTag"
              (click)="bookingTagClicked($event, tag)" [class.selected]="selectedTags?.has(tag)">
              <div class="tag-content">
                <span class="tag-text">{{ tag }}</span>
              </div>
              <div class="tag-check" *ngIf="selectedTags?.has(tag)">
                <i class="fa-solid fa-check"></i>
              </div>
            </div>
            <div class="tag-item" *ngFor="let tag of userTags; trackBy: trackByTag"
              (click)="bookingTagClicked($event, tag)" [class.selected]="selectedTags?.has(tag)">
              <div class="tag-content">
                <span class="tag-text">{{ tag }}</span>
              </div>
              <div class="tag-check" *ngIf="selectedTags?.has(tag)">
                <i class="fa-solid fa-check"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      }@else {
      <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
      <!-- Title -->
      <div class="story__title">{{ displayTitle }}</div>

      <!-- Content -->
      <div class="story__desc" [innerHTML]="displayText"></div>

      }
    </div>
  </div>

  <!-- Action Buttons -->
  <div class="story__actions">
    <button class="my-button-3 no-animate story__next" *ngIf="hasNextPage()" (click)="nextPage()">Next</button>
    <div class="story__action-buttons" *ngIf="isLastPage || contentList.length === 0">
      <button class="my-button-3 no-animate story__gotit" (click)="gotIt()">WhatsApp</button>
      <button class="my-button-3 no-animate story__booknow" *ngIf="bookNowText" (click)="bookNow()">{{ bookNowText
        }}</button>
    </div>
  </div>

  <ng-template #iconTemplate>
    <!-- Icon Display -->
    <div class="story__icon" *ngIf="displayIcon" [ngStyle]="displayColor ? getColorStyle(displayColor) : {}">
      <img *ngIf="isIconImage()" [src]="getIconImageUrl()" alt="Icon" class="story__icon-image mx-auto">
      <i *ngIf="!isIconImage()" [class]="displayIcon" class="mx-auto"></i>
    </div>

    <!-- Default SVG (shown only if no content items or no icon) -->
    <svg viewBox="0 0 1618 1751" fill="none" *ngIf="!displayIcon">
      <path
        d="M654.525 963.389C600.672 909.536 558.965 846.715 530.561 776.672C503.138 709.048 489.233 637.609 489.234 564.34C489.233 491.071 503.138 419.632 530.561 352.008C558.964 281.965 600.672 219.144 654.525 165.291C708.378 111.438 771.198 69.731 841.242 41.327C908.866 13.904 980.304 0 1053.57 0C1126.84 0 1198.28 13.904 1265.91 41.327C1335.95 69.731 1398.77 111.438 1452.62 165.291C1506.47 219.144 1548.18 281.965 1576.59 352.007C1604.01 419.632 1617.91 491.07 1617.91 564.339C1617.91 637.608 1604.01 709.047 1576.59 776.671C1548.18 846.714 1506.48 909.535 1452.62 963.388C1398.77 1017.24 1335.95 1058.95 1265.91 1087.35C1198.28 1114.78 1126.84 1128.68 1053.57 1128.68C980.304 1128.68 908.865 1114.78 841.241 1087.35C771.199 1058.95 708.378 1017.24 654.525 963.389ZM1369.67 248.242C1326.98 205.551 1277.24 172.511 1221.82 150.039C1168.27 128.322 1111.66 117.31 1053.57 117.31C995.486 117.31 938.88 128.322 885.325 150.039C829.91 172.51 780.166 205.551 737.474 248.242C694.783 290.933 661.742 340.677 639.271 396.093C617.554 449.648 606.542 506.254 606.542 564.341C606.542 622.428 617.554 679.034 639.271 732.589C661.743 788.005 694.783 837.748 737.474 880.44C780.165 923.131 829.909 956.172 885.325 978.643C938.88 1000.36 995.486 1011.37 1053.57 1011.37C1111.66 1011.37 1168.27 1000.36 1221.82 978.643C1277.24 956.171 1326.98 923.131 1369.67 880.44C1412.36 837.749 1445.4 788.005 1467.88 732.589C1489.59 679.034 1500.6 622.428 1500.6 564.341C1500.6 506.254 1489.59 449.647 1467.88 396.093C1445.4 340.678 1412.36 290.933 1369.67 248.242Z"
        fill="#4EC67F" />
      <path
        d="M691.829 1026.53L596.346 1122.01L495.9 1021.57L591.383 926.085C605.953 944.633 621.706 962.395 638.612 979.301C655.518 996.207 673.282 1011.96 691.829 1026.53Z"
        fill="#1B2D38" />
      <path
        d="M28.9755 1588.94C-9.6585 1550.3 -9.6585 1487.66 28.9755 1449.03L460.256 1017.75L600.163 1157.66L168.882 1588.94C130.248 1627.57 67.6105 1627.57 28.9755 1588.94Z"
        fill="#1B2D38" />
      <path
        d="M1232.99 376.718L996.303 613.406L864.515 481.619L775.346 570.788L996.303 791.744L1322.16 465.887L1232.99 376.718Z"
        fill="#4EC67F" />
      <path
        d="M808.957 1750.98C1212.29 1750.98 1539.25 1739.46 1539.25 1725.25C1539.25 1711.04 1212.29 1699.52 808.957 1699.52C405.626 1699.52 78.6621 1711.04 78.6621 1725.25C78.6621 1739.46 405.626 1750.98 808.957 1750.98Z"
        fill="#DDDDDD" />
    </svg>
  </ng-template>
</div>